const trueToken = 'true'
const falseToken = 'false'

export default {
  id : 'Expression.FieldParser.ConstantBooleanField',
  type : 'booleanField',
  sort : -5,
  handles : ( field, context ) => {
    const test = field.value?.trim()?.toLowerCase()
    return field.type === 'ExpressionParser.Field' && (
      test === trueToken ||
      test === falseToken
    )
  },
  parse : async ( field, context ) => {
    const toReturn = {
      type : 'ExpressionField.boolean',
      // we can rely on this because of the handles
      value : field.value?.trim()?.toLowerCase() === trueToken,
    }
    if ( context?.includeAstInfo ) {
      toReturn.absoluteLocation = {
        startIndex : field.startIndex,
        endIndex : field.endIndex,
      }
      toReturn.relativeLocation = {
        startIndex : 0,
        endIndex : field.untrimmed?.length
      }
      toReturn.untrimmed = field.untrimmed
    }
    return toReturn
  }
}
